import ApplicationController from './application_controller';

/*
 * This controller is intentionally empty.
 * Its presence on an element is all that's needed to connect it to
 * the StimulusReflex lifecycle. The actual pagination logic lives in
 * the AuditLogReflex class on the server.
*/
export default class extends ApplicationController {
}